export default __webpack_public_path__ + "static/media/work-nvite.a140e7d2.png";